import type { ThreadTopicSummary } from '@shared/types/thread-work';
import type { WorkRun } from '@/lib/work-runs';

const time = (date: Date) => date.toLocaleTimeString('fr-FR', { hour: 'numeric', minute: '2-digit' }).replace(':', ' h ');
const day = (date: Date) => date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
const sameDay = (left: Date, right: Date) => left.toDateString() === right.toDateString();

/** When a run finished, short: « 10 h 06 » today, « hier », « 13 oct. » before. */
export const whenDone = (iso: string, now: Date): string => {
  const date = new Date(iso);
  if (sameDay(date, now)) return time(date);
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  return sameDay(date, yesterday) ? 'hier' : day(date);
};

/**
 * The line under a task: its last finished action (« ✓ 13 oct. · Ajouter au
 * CRM »), with who ran it when it was not me. A failed one says so, in grey.
 */
export const lastDoneLine = (run: WorkRun, now: Date, me: string | null, nameOf: (userId: string) => string): string => {
  const who = me && run.requesterUserId !== me ? ` · ${nameOf(run.requesterUserId)}` : '';
  return `${run.status === 'failed' ? 'Échec' : '✓'} ${whenDone(run.finishedAt, now)} · ${run.label}${who}`;
};

/**
 * A task that ran an action and goes on with a new proposal keeps its first
 * title (« Ajouter Dolead au CRM ») although that is done: its title becomes
 * the step it now proposes. Without a new proposal, it keeps its title.
 */
export const currentTitle = (topic: Pick<ThreadTopicSummary, 'title' | 'proposal'>, run: WorkRun | undefined): string =>
  run && topic.proposal && topic.proposal.id !== run.proposalId ? topic.proposal.ctaLabel : topic.title;
